import React from 'react';
import StatsBar from './StatsBar';
import { VALUE_PROPS } from '../../../config/socialProof';
import './HeroSection.css';

/**
 * HeroSection Component
 * Modern hero banner with animated gradient blobs, headline, and stats
 * Inspired by MissionCritical.llc design patterns
 */
const HeroSection = () => {
    const heroContainerStyle = {
        position: 'relative',
        width: '100%',
        padding: '60px 24px',
        textAlign: 'center',
        color: '#FFFFFF',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #0066CC 0%, #004C99 50%, #003366 100%)',
    };

    const contentStyle = {
        position: 'relative',
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
    };

    const headlineStyle = {
        fontSize: '48px',
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: '20px',
        color: '#FFFFFF',
        textShadow: '0 2px 20px rgba(0, 0, 0, 0.2)',
    };

    const subheadlineStyle = {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: 1.6,
        color: 'rgba(255, 255, 255, 0.95)',
        maxWidth: '700px',
        margin: '0 auto 32px',
        textShadow: '0 1px 10px rgba(0, 0, 0, 0.15)',
    };

    return (
        <div className="hero-section" style={heroContainerStyle}>
            {/* Animated gradient blobs */}
            <div className="gradient-blob blob-1" />
            <div className="gradient-blob blob-2" />
            <div className="gradient-blob blob-3" />
            <div className="gradient-blob blob-4" />

            {/* Content */}
            <div style={contentStyle}>
                <h1 style={headlineStyle}>{VALUE_PROPS.primary}</h1>
                <p style={subheadlineStyle}>{VALUE_PROPS.secondary}</p>
                <StatsBar />
            </div>
        </div>
    );
};

export default HeroSection;
